import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import './othergames.css'


const OtherGames = ()=>{
    useEffect(() => {
        Aos.init({ duration: 1000, offset: 250 });
    });
    return(
       
            <div className="container mb-5">
                <div className="row justify-content-around" >
                    <div data-aos="zoom-in" className="col-md-3 col-10 p-0 bg-light rounded-4 card-exterior other-game-card" >
                        <div className="rounded-4 mx-3 mt-3 bg-danger position-relative card-interior" >
                            <img className="card-img-top image-pop-out rounded-4 position-absolute" src="https://png.pngtree.com/png-vector/20240107/ourmid/pngtree-a-sell-phone-and-its-app-png-image_11426979.png" alt=""></img>
                        </div>
                        <div className="text-center graffiti-text">Mobile App Games</div>
                    </div>
                    <div data-aos="zoom-in" className="col-md-3 col-10 p-0 bg-light rounded-4 card-exterior other-game-card" >
                        <div className="rounded-4 mx-3 mt-3 bg-warning position-relative card-interior" >
                            <img className="card-img-top image-pop-out rounded-4 position-absolute" src="https://www.starfall.com/h/_images/index-css/grades45.png" alt=""></img>
                        </div>
                        <div className="text-center graffiti-text">Educational Games</div>
                    </div>
                    <div data-aos="zoom-in" className="col-md-3 col-10 p-0 bg-light rounded-4 card-exterior other-game-card" >
                        <div className="rounded-4 mx-3 mt-3 bg-info position-relative card-interior" >
                            <img className="card-img-top rounded-4 image-pop-out position-absolute" src="https://png.pngtree.com/png-vector/20230728/ourmid/pngtree-congress-clipart-the-united-states-government-building-illustration-with-a-meeting-vector-png-image_6805396.png" alt=""></img>
                        </div>
                        <div className="text-center graffiti-text">Govt. Sector Games</div>
                    </div>
                    
                </div>

                <div className="row justify-content-around" >
                    <div data-aos="zoom-in" className="col-md-3 col-10 p-0 bg-light rounded-4 card-exterior other-game-card" >
                        <div className="rounded-4 mx-3 mt-3 bg-warning position-relative card-interior" >
                            <img className="card-img-top rounded-4 image-pop-out position-absolute" src="https://png.pngtree.com/png-vector/20241019/ourmid/pngtree-travel-adventure-with-landmarks-png-image_14116809.png" alt=""></img>
                        </div>
                        <div className="text-center graffiti-text">Tourism Games</div>
                    </div>
                    <div data-aos="zoom-in" className="col-md-3 col-10 p-0 bg-light rounded-4 card-exterior other-game-card" >
                        <div className="rounded-4 mx-3 mt-3 bg-info position-relative card-interior" >
                            <img className="card-img-top rounded-4 image-pop-out position-absolute" src="https://png.pngtree.com/png-vector/20230518/ourmid/pngtree-2d-game-art-natural-landscape-for-games-background-vector-illustration-png-image_7101456.png" alt=""></img>
                        </div>
                        <div className="text-center graffiti-text">2D Games</div>
                    </div>
                    <div data-aos="zoom-in" className="col-md-3 col-10 p-0 bg-light rounded-4 card-exterior other-game-card" >
                        <div className="rounded-4 mx-3 mt-3 bg-danger position-relative card-interior" >
                            <img className="card-img-top rounded-4 image-pop-out position-absolute" src="https://freepngimg.com/save/83120-toy-sprite-yellow-2d-game-computer-graphics/600x500" alt=""></img>
                        </div>
                        <div className="text-center graffiti-text">3D Games</div>
                    </div>
                </div>
            </div>
        
    )
}

export default OtherGames;